import { PropsWithChildren } from 'react';
import cx from 'classnames';

import { ComponentContent, ComponentsWrapper, CONTENT_SIZES } from 'Layout';

import styles from './ContentLayout.module.scss';

type ColumnDirection = 'reverse' | 'normal';

interface ContentLayoutProps extends PropsWithChildren {
  columnDirection?: ColumnDirection;
}

export const ContentLayout = ({ children, columnDirection = 'reverse' }: ContentLayoutProps) => (
  <ComponentsWrapper className={styles.wrapper} selector="main">
    <ComponentContent
      className={cx(styles.content, styles[columnDirection === 'reverse' ? 'directionReverse' : 'directionNormal'])}
      maxWidth={CONTENT_SIZES.container}
    >
      {children}
    </ComponentContent>
  </ComponentsWrapper>
);

export const Article = ({ children }: PropsWithChildren) => (
  <ComponentContent
    className={cx(styles.contentBox, styles.article)}
    paddings={false}
    selector="article"
  >
    <>
      {children}
    </>
  </ComponentContent>
);

export const Aside = ({ children }: PropsWithChildren) => (
  <ComponentContent
    className={cx(styles.contentBox, styles.aside)}
    paddings={false}
    selector="aside"
  >
    {children}
  </ComponentContent>
);
